import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { Home, LayoutGrid, Search, Star, MessageSquare } from 'lucide-react';

const navItems = [
  { path: '/accueil', label: 'Accueil', icon: Home },
  { path: '/categories', label: 'Categories', icon: LayoutGrid },
  { path: '/recherche', label: 'Recherche', icon: Search },
  { path: '/favoris', label: 'Favoris', icon: Star },
  { path: '/assistant', label: 'Assistant', icon: MessageSquare },
];

const Layout = () => {
  return (
    <div className="app-layout">
      <div className="app-content">
        <Outlet />
      </div>
      <nav className="bottom-nav" data-testid="bottom-nav">
        {navItems.map(({ path, label, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
            data-testid={`nav-${label.toLowerCase()}`}
          >
            <Icon />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Layout;
